import { render, staticRenderFns } from "./AddPrivacyAndPolicy.vue?vue&type=template&id=30cc1561&scoped=true&"
import script from "./AddPrivacyAndPolicy.vue?vue&type=script&lang=js&"
export * from "./AddPrivacyAndPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc1561",
  null
  
)

export default component.exports